import React, { useEffect, useState } from "react";
import "./BeneficiaryCard.css";
import { Button } from "components/Buttons";
import ShowToast from "components/ShowToast";
import { getAllBanks, moneyTransferAction } from "service/Auth.services";
import APP_CONFIG, { MONEY_TRANSFER_ACTION } from "constants/app";

const tabsNames = ["Beneficiary List", "Add Beneficiary"];


const BeneficiaryCard = ({
  bankData,
  setBankData,
  beneData,
  setBeneData,
  bankOptions ,
  phone,
  userId,
  location,
  onSelectBeneficiary
}) => {
  const fields = [
    
    { id: "mobile", label: "Mobile Number", name: "mobile" },
   
  ];

  const [selectedTab, setSelectedTab] = useState("Beneficiary List");
  const [selectedValue, setSelectedValue] = useState("");
 
  const [formData, setFormData] = useState({
    
    mobile: ""
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [fromListClick, setFromListClick] = useState(false); // NEW

const filteredBeneficiaries = beneData?.beneDetails?.filter((item) => {
  const name =
    item?.beneName &&
    item.beneName !== "undefined"
      ? item.beneName.toLowerCase()
      : "";

  const mobile = item?.mobile?.toLowerCase() || "";

  const term = searchTerm?.toLowerCase() || "";

  return name.includes(term) || mobile.includes(term);
});



 useEffect(() => {
  console.log("bankData:", bankData);
}, [bankData]);


  const handleChange = async (e) => {
    const { name, value } = e.target;
    let updatedValue = name === "phone" ? value.replace(/\D/g, "") : value;

    setFormData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    

    const _formData = new FormData();
    _formData.set("userid", userId);
    _formData.set("phone", phone);
    _formData.set("mobile", formData.mobile);
    _formData.set("lat", location.lat);
    _formData.set("long", location.lng);
    const res = await moneyTransferAction(_formData, MONEY_TRANSFER_ACTION.ADD_BENE);
    if (!res || !res.status) {
      ShowToast(res.data||"No Data Found", "danger");
    } else if (res?.status) {
      ShowToast(res.data||"Details found", "success");
    }
    return res;
  };

 

  const resetBeneficiaryFormHandler = () => {
    setFormData({
      userId,
      mobile: "",
      
    });
    setFromListClick(false); // <-- NEW
  };

  return (
    <div className="card">
      <div className="card-header beneficiary-header">
         <ul className="nav beneficiary-tabs" role="tablist">
    {tabsNames.map((tab) => (
      <li className="nav-item" role="presentation" key={tab}>
        <button
          type="button"
          className={`nav-link ${
            selectedTab === tab ? "active" : ""
          }`}
          onClick={() => setSelectedTab(tab)}
        >
          {tab}
        </button>
      </li>
    ))}
  </ul>
        <div className="beneficiary-header-bottom">
    <h5 className="beneficiary-title">{selectedTab}</h5>

    {selectedTab === "Add Beneficiary" && (
      <Button size="sm" className="reset-btn" onClick={resetBeneficiaryFormHandler}>
        Reset
      </Button>
    )}
  </div>
      </div>

      <div className="card-body">
        {selectedTab === "Beneficiary List" && (
          <div>
            <div className="mb-3">
              <input
                aria-label="Search"
                className="fuzzy-search form-control search b-r-22"
                placeholder="Search..."
                type="search"
                value={searchTerm}
                onChange={handleInputChange}
              />
            </div>
            <ul className="list fuzzy-list">
           
            {filteredBeneficiaries && filteredBeneficiaries.length > 0 ? (
  filteredBeneficiaries.map((item, index) => (
   <li
  key={item.id}
  className="beneficiary-card cursor-pointer"  onClick={() => onSelectBeneficiary(item)}
>
  <div className="beneficiary-card-content">

    {/* Avatar */}
    <div className="beneficiary-avatar">
      {(item.beneName || item.mobile)?.slice(0, 2).toUpperCase()}
    </div>

    {/* Info */}
    <div className="beneficiary-info">
      <p className="beneficiary-name">
        {item.beneName || "Unnamed Beneficiary"}
      </p>

      <span className="beneficiary-subtext">
        {item.mobile}
      </span>

      <span className="beneficiary-subtext text-muted">
        A/C • {item.account} | IFSC • {item.ifsc}
      </span>
    </div>

  </div>
</li>

  ))
) : (
  <li className="text-muted text-center">
    No matching beneficiaries found
  </li>
)}

            </ul>
          </div>
        )}

        {selectedTab === "Add Beneficiary" && (
          <form
            onSubmit={handleSubmit}
            className="app-form px-3 overflowY"
            style={{ height: "40dvh" }}
          >
           

            {fields
              .filter((field) => fromListClick || field.id !== "userId")
              .map((fieldData) => (
                <div className="row mt-3" key={fieldData.id}>
                  <div className="col-md-12">
                    <div className="floating-form">
                      <input
                        type="text"
                        name={fieldData.name}
                        className="form-control"
                        placeholder={`Enter ${fieldData.label}`}
                        value={formData[fieldData.name]}
                        onChange={handleChange}
                        disabled={loading}
                        maxLength={fieldData.id === "phone" ? 10 : undefined}
                      />
                      <label className="form-label">{fieldData.label}</label>
                      {errors[fieldData.name] && (
                        <div className="error-message">
                          {errors[fieldData.name]}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}

            {!fromListClick && (
              <div className="d-flex justify-content-end py-4">
                <Button className="ellipsis" type="submit">
                  Add Beneficiary
                </Button>
              </div>
            )}
          </form>
        )}
      </div>
    </div>
  );
};

export default BeneficiaryCard;
